import { FadeIn, Overline } from "@/components/Reveal";

const STEPS = [
  {
    n: "1",
    title: "Understand",
    text: "Understand the brand, objectives and target audience.",
  },
  {
    n: "2",
    title: "Identify",
    text: "Identify suitable informational creators.",
  },
  {
    n: "3",
    title: "Coordinate",
    text: "Coordinate sponsorship proposals and agreements.",
  },
  {
    n: "4",
    title: "Deliver",
    text: "Support campaign delivery and review available performance data.",
  },
];

export const Process = () => (
  <section id="process" className="py-24 md:py-32" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <FadeIn className="max-w-3xl">
        <Overline>Our Process</Overline>
        <h2 className="mt-6 font-serif text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight">
          From brief to broadcast.
        </h2>
      </FadeIn>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
        {STEPS.map((s, i) => (
          <FadeIn key={s.n} delay={i * 0.1}>
            <div className="border-t-2 border-ink pt-8" data-testid={`process-step-${s.n}`}>
              <span className="font-serif italic text-5xl md:text-6xl text-outline">{s.n}</span>
              <h3 className="mt-6 font-serif text-2xl tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm text-charcoal/70 leading-relaxed">{s.text}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
